export const REQUEST_AUDIT_FORM_ACTION = "https://forms.quantstamp.com/submit/audit-request";

export const projectTypes = [
  ["Bridge", "Bridge / Crosschain"],
  ["CEX", "Centralized Exchange (CEX)"],
  ["DAO", "DAO"],
  ["dAPP", "dApp"],
  ["DeFi", "DeFi"],
  ["GameFi", "GameFi"],
  ["Governance", "Governance"],
  ["Infrastructure", "Infrastructure"],
  ["Layer 1", "Layer 1 Blockchain (L1)"],
  ["Layer 2", "Layer 2 Blockchain (L2)"],
  ["NFT", "NFT"],
  ["Oracle", "Oracle"],
  ["Stablecoin", "Stablecoin"],
  ["Token Contract", "Token Contract"],
  ["Wallet", "Wallet"],
  ["Web2", "Web 2.0 (Penetration Testing)"],
  ["Other", "Other"],
] as const;

export const requestAuditClientLogos = [
  { src: "/images/eth2.png", alt: "Ethereum 2.0" },
  { src: "/images/virtual-protocol.png", alt: "Virtual Protocol" },
  { src: "/images/ethena.png", alt: "Ethena" },
  { src: "/images/solana_1.png", alt: "Solana" },
  { src: "/images/ton_1.png", alt: "TON" },
  { src: "/images/alchemy.png", alt: "Alchemy" },
  { src: "/images/curve.png", alt: "Curve" },
  { src: "/images/kiln.svg", alt: "Kiln" },
  { src: "/images/visa.png", alt: "Visa" },
  { src: "/images/OpenAI.svg", alt: "OpenAI" },
] as const;
